import React, { useEffect, useState } from 'react';
import {
  Box,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tooltip,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { fetchOrgSettingsRequest, updateOrgSettingsRequest } from '../../../api/organizations/orgSlice';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const BulkUploadEmailSettings = () => {
  const dispatch = useDispatch();
  const { settings } = useSelector((state) => state.org);

  const [bulkUploadPreference, setBulkUploadPreference] = useState({
    send_email_on_completion: false,
  });

  const {
    handleSubmit: validateEmail,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    dispatch(fetchOrgSettingsRequest());
  }, [dispatch]);

  useEffect(() => {
    if (settings?.bulk_upload_notifications) {
      setBulkUploadPreference({
        ...settings.bulk_upload_notifications,
      });
    }
  }, [settings]);

  const handleSubmit = (updated = {}) => {
    dispatch(
      updateOrgSettingsRequest({
        updates: {
          bulk_upload_notifications: {
            ...bulkUploadPreference,
            ...updated,
          },
        },
      }),
    );
  };

  const handleToggleChange = (field) => {
    const updated = { ...bulkUploadPreference, [field]: !bulkUploadPreference[field] };
    setBulkUploadPreference(updated);
    handleSubmit(updated);
  };

  return (
    <Paper elevation={0} sx={{ mt: 5 }}>
      <Typography variant="h6" sx={{ mb: '1.5rem' }}>
        Bulk Upload Notifications
        <Divider />
      </Typography>

      <Grid container>
        <Grid size={4.5}>
          <FormGroup>
            <FormControlLabel
              control={
                <Switch
                  checked={bulkUploadPreference.send_email_on_completion}
                  onChange={() => handleToggleChange('send_email_on_completion')}
                />
              }
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  {'Bulk Upload Completion'}
                  <Tooltip title="When enabled, the user who initiated the bulk upload and the root user of the organization will be notified via email once the job has finished processing.">
                    <IconButton size="small">
                      <InfoOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              labelPlacement="start"
              sx={{ ml: 0, justifyContent: 'space-between', width: '100%' }}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default BulkUploadEmailSettings;
